"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptimizedImg = exports.getOptimizedSrc = void 0;
const react_1 = __importStar(require("react"));
const react_utils_1 = require("@sravni/react-utils");
const SUPPORTED_IMAGES_EXTENSIONS = ['jpg', 'jpeg', 'png', 'svg', 'webp'];
const COMPRESSIONS = ['xl', 'l', 'm', 's', 'xs', 't'];
const getOptimizedSrc = (src, compressValue) => {
    if (!src)
        return src;
    const arr = src.split('.');
    const extension = arr[arr.length - 1].toLowerCase();
    if (SUPPORTED_IMAGES_EXTENSIONS.includes(extension)) {
        arr.splice(arr.length - 2, 1, `${arr[arr.length - 2]}-${compressValue}`);
        return arr.join('.');
    }
    else {
        return src;
    }
};
exports.getOptimizedSrc = getOptimizedSrc;
exports.OptimizedImg = (0, react_1.memo)((_a) => {
    var { src, compression } = _a, props = __rest(_a, ["src", "compression"]);
    const isPhone = (0, react_utils_1.useIsPhone)();
    const isTablet = (0, react_utils_1.useIsTablet)();
    const isMobile = (0, react_utils_1.useIsMobile)();
    const compressValue = (0, react_1.useMemo)(() => {
        let output = 0;
        if (isTablet)
            output += 2;
        if (isPhone)
            output += 3;
        if (compression === 'auto') {
            return COMPRESSIONS[Math.max(0, output)];
        }
        else if (isMobile) {
            return compression[1];
        }
        else
            return compression[0];
    }, [compression, isMobile, isPhone, isTablet]);
    // TODO: доделать прелодер для картинок
    const getSrc = (0, react_1.useMemo)(() => {
        return (0, exports.getOptimizedSrc)(src, compressValue);
    }, [compressValue, src]);
    return react_1.default.createElement("img", Object.assign({ onLoad: () => { }, src: getSrc }, props));
});
